import type { ContractViewModel } from '@trinnvis/dabih-api-client';

import { _sortByName } from '../utilities/_sortByName';

export function _filterByEmployeeId(list: ContractViewModel[], uuid?: string): ContractViewModel[] {
  if (!list || !uuid) {
    return [];
  }

  return list
    .filter((item) => {
      if (!item.employees) {
        return false;
      }
      return item.employees.includes(uuid);
    })
    .sort(_sortByName);
}
